import { render, staticRenderFns } from "./LoggerView.vue?vue&type=template&id=b94b9b4c&scoped=true"
import script from "./LoggerView.vue?vue&type=script&lang=js"
export * from "./LoggerView.vue?vue&type=script&lang=js"
import style0 from "./LoggerView.vue?vue&type=style&index=0&id=b94b9b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94b9b4c",
  null
  
)

export default component.exports